import Vue from 'vue';
import type { ModuleTree } from 'vuex';
import Vuex from 'vuex';
import requestsLoadPlugin from '@/utils/requests';

Vue.use(Vuex);

interface ModuleState {}

import app from './modules/app'; //---#todo relocate to here methods from system, setting stores
import auth from './modules/auth';
import basket from './modules/basket';
import blog from './modules/blog';
import catalog from './modules/catalog';
import comments from './modules/comments';
import courses from './modules/courses';
import documents from './modules/documents';
import favorites from './modules/favorites';
import filters from './modules/filters';
import gifts from './modules/gifts';
import home from './modules/home';
import ingredients from './modules/igrendients';
import managers from './modules/managers';
import metodist from './modules/metodist';
import order from './modules/order';
import outlet from './modules/outlet';
import pages from './modules/pages';
import popups from './modules/popups';
import products from './modules/products';
import profile from './modules/profile';
import pushes from './modules/pushes';
import remainings from './modules/remainings';
import reviews from './modules/reviews';
import sales from './modules/sales';
import samples from './modules/samples';
import search from './modules/search';
import selection from './modules/selection';
import seminars from './modules/seminars';
import setting from './modules/setting';
import staticPages from './modules/static-pages';
import system from './modules/system';


const modules: ModuleTree<ModuleState> = {
  app,
  auth,
  basket,
  blog,
  catalog,
  comments,
  courses,
  documents,
  favorites,
  filters,
  gifts,
  home,
  ingredients,
  managers,
  metodist,
  order,
  outlet,
  pages,
  popups,
  products,
  profile,
  pushes,
  remainings,
  reviews,
  sales,
  samples,
  search,
  selection,
  seminars,
  setting,
  staticPages,
  system
};

export interface RootState {}

requestsLoadPlugin();

const store = new Vuex.Store({
  modules,
  state: {
    isAllRequestsCompleted: false
  },
  getters: {
    isAllRequestsCompleted: (state) => state.isAllRequestsCompleted
  },
  mutations: {
    SET_REQUESTS_COMPLETED_STATUS(state, value) {
      state.isAllRequestsCompleted = value;
    }
  },
  plugins: [requestsLoadPlugin()]
});

// @ts-ignore
export default store;
